import api from '@/lib/axios';
import { useAuthStore } from '@/stores/auth-store';
import { useNetworkStore } from '@/stores/network-store';

export const authService = {
  async login(username: string, password: string) {
    try {
      const response = await api.post('/auth/login', { username, password });
      const { user, accessToken, refreshToken } = response.data;
      useAuthStore.getState().setAuth(user, accessToken, refreshToken);
      return response.data;
    } catch (error: any) {
      const mode = useNetworkStore.getState().mode;
      // Si estamos en local y falló, intentamos hacer fallback a la nube
      if (mode === 'local_master' || mode === 'local_client' || mode === 'local' || mode === 'unconfigured') {
        if (error.response?.status === 401 || error.response?.status === 404 || error.message.includes('Network')) {
          console.log('Login local falló, intentando en la nube...');
          try {
            const cloudResponse = await api.post('/auth/login', { username, password }, {
              headers: { 'x-bypass-local': 'true' }
            });
            const { user, accessToken, refreshToken } = cloudResponse.data;
            useAuthStore.getState().setAuth(user, accessToken, refreshToken);
            
            // Si es master o local, guardamos el usuario y su hash localmente para el próximo inicio offline
            if (mode === 'local_master' || mode === 'local' || mode === 'unconfigured') {
              try {
                await api.post('/auth/cache-user', { user, rawPassword: password });
              } catch (e) {
                console.error('Error guardando usuario localmente', e);
              }
            }
            return cloudResponse.data;
          } catch (cloudErr) {
            throw cloudErr; // Re-lanza el error real (ej. Contraseña incorrecta de la nube)
          }
        }
      }
      throw error;
    }
  },

  async register(data: {
    username: string;
    email: string;
    password: string;
    fullName: string;
  }) {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  async getProfile() {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  logout() {
    useAuthStore.getState().logout();
  },
};
